import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, AlertTriangle } from 'lucide-react';
export const DisclosuresPage = () => {
  const lastUpdated = 'September 15, 2023';
  return <div className="min-h-screen flex flex-col" data-id="element-413">
      <Header data-id="element-414" />
      <main className="flex-grow pt-20" data-id="element-415">
        {/* Hero Banner */}
        <div className="bg-[#0a2351] text-white py-16" data-id="element-416">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-417">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-418">Disclosures</h1>
            <p className="text-xl text-gray-200 max-w-2xl" data-id="element-419">
              Important information about our investment activities and
              regulatory compliance
            </p>
            <nav className="flex mt-6" aria-label="Breadcrumb" data-id="element-420">
              <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-421">
                <li className="inline-flex items-center" data-id="element-422">
                  <a href="/" className="text-gray-300 hover:text-white" data-id="element-423">
                    Home
                  </a>
                </li>
                <li data-id="element-424">
                  <div className="flex items-center" data-id="element-425">
                    <ChevronRight className="w-4 h-4 text-gray-300" data-id="element-426" />
                    <span className="ml-1 text-white md:ml-2" data-id="element-427">Disclosures</span>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Disclosures Content */}
        <section className="py-12 bg-white" data-id="element-428">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-429">
            <div className="max-w-4xl mx-auto" data-id="element-430">
              <div className="bg-white rounded-lg shadow-sm p-8 mb-8" data-id="element-431">
                <div className="mb-8 text-sm text-gray-500" data-id="element-432">
                  Last Updated: {lastUpdated}
                </div>
                <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mb-8" data-id="element-433">
                  <div className="flex items-center" data-id="element-434">
                    <AlertTriangle className="h-6 w-6 text-amber-500 mr-3" data-id="element-435" />
                    <p className="text-amber-700 font-medium" data-id="element-436">
                      This information is provided for informational purposes
                      only and does not constitute an offer to sell or
                      solicitation of an offer to buy any securities.
                    </p>
                  </div>
                </div>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-437">
                  Regulatory Information
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-438">
                  Sapis Capital Group ("Sapis") is a registered investment
                  adviser with the U.S. Securities and Exchange Commission
                  (SEC). Registration as an investment adviser does not imply
                  any level of skill or training. The information contained in
                  this website has not been approved or verified by the SEC or
                  by any state securities authority.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-439">
                  Investment Risks
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-440">
                  All investments involve risk, including the possible loss of
                  principal. Past performance is not indicative of future
                  results. Different types of investments involve varying
                  degrees of risk, and there can be no assurance that the future
                  performance of any specific investment, investment strategy,
                  or product made reference to directly or indirectly on this
                  website will be profitable, equal any corresponding indicated
                  historical performance level(s), or be suitable for your
                  portfolio.
                </p>
                <p className="mb-8 text-gray-700" data-id="element-441">
                  Due to various factors, including changing market conditions,
                  the content of this website may no longer be reflective of
                  current opinions or positions. Moreover, you should not assume
                  that any discussion or information contained on this website
                  serves as the receipt of, or as a substitute for, personalized
                  investment advice from Sapis.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-442">
                  Forward-Looking Statements
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-443">
                  This website may contain certain forward-looking statements.
                  Forward-looking statements are subject to numerous
                  assumptions, risks, and uncertainties, which change over time.
                  Forward-looking statements speak only as of the date they are
                  made, and Sapis assumes no duty to and does not undertake to
                  update forward-looking statements. Actual results could differ
                  materially from those anticipated in forward-looking
                  statements.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-444">
                  Third-Party Information
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-445">
                  Certain portions of this website may contain information
                  prepared by third parties, which is believed to be reliable.
                  However, Sapis has not verified this information and makes no
                  representations about the accuracy or completeness of such
                  information. The use of such sources does not constitute an
                  endorsement by Sapis.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-446">
                  Performance Information
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-447">
                  Any performance data quoted represents past performance. Past
                  performance does not guarantee future results. Current
                  performance may be lower or higher than the performance
                  quoted. The investment return and principal value of an
                  investment will fluctuate so that an investor's shares, when
                  redeemed, may be worth more or less than their original cost.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-448">
                  Private Funds
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-449">
                  Information regarding private fund investments is subject to
                  additional limitations. The private funds are not registered
                  under the Investment Company Act of 1940, as amended, and
                  their interests are offered pursuant to exemptions provided by
                  Section 4(a)(2) of the Securities Act of 1933, as amended, and
                  Regulation D promulgated thereunder.
                </p>
                <p className="mb-8 text-gray-700" data-id="element-450">
                  The information provided about private funds is qualified in
                  its entirety by the respective fund's offering documents,
                  including the private placement memorandum, limited
                  partnership agreement, subscription agreement, and other
                  important information that should be read carefully before
                  investing.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-451">
                  Form ADV
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-452">
                  A copy of Sapis's current written disclosure statement as set
                  forth on Form ADV, discussing our advisory services and fees,
                  is available upon request. Sapis does not make any
                  representations or warranties as to the accuracy, timeliness,
                  suitability, completeness, or relevance of any information
                  prepared by any unaffiliated third party, whether linked to
                  Sapis's website or incorporated herein, and takes no
                  responsibility for any such content.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-453">
                  Contact Us
                </h2>
                <p className="text-gray-700" data-id="element-454">
                  If you have any questions about these disclosures, please
                  contact us at:
                </p>
                <div className="mt-4 text-gray-700" data-id="element-455">
                  <p data-id="element-456">Sapis Capital Group</p>
                  <p data-id="element-457">123 Finance Street, Suite 500</p>
                  <p data-id="element-458">New York, NY 10001</p>
                  <p data-id="element-459">Email: compliance@sapiscapital.com</p>
                  <p data-id="element-460">Phone: (212) 555-0123</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-461" />
    </div>;
};